import React from "react";
import "../styles/Footer.css";
import { FaInstagram, FaLinkedin, FaGithub, FaGlobe } from "react-icons/fa";
import LogoFooter from "../assets/arcFooter.png"; // ajuste o caminho se necessário

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <img src={LogoFooter} alt="Logo ARC" className="footer-logo" />
          <p>Revolucionando a gestão de consultórios com Inteligência Artificial.</p>
        </div>

        <div className="footer-links">
          <h4>Links Rápidos</h4>
          <ul>
            <li><a href="#sobreNos">Sobre</a></li>
            <li><a href="#beneficios">Conheça</a></li>
            <li><a href="#clientes">Clientes</a></li>
            <li><a href="#pricing">Preços</a></li>            
          </ul>
        </div>

        <div className="footer-social">
          <h4>Conecte-se</h4>
          <div className="social-icons">
            <a href="#teste" aria-label="Instagram"><FaInstagram /></a>
            <a href="#teste" aria-label="LinkedIn"><FaLinkedin /></a>
            <a href="#teste" aria-label="GitHub"><FaGithub /></a>
            <a href="#teste" aria-label="Website"><FaGlobe /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} ARC Assistant. Todos os direitos reservados.</p>
        <p className="desenvolvido">Desenvolvido por <a href="https://e2tcode.com" target="_blank" rel="noopener noreferrer">E2T Code</a></p>
      </div>
    </footer>
  );
}

export default Footer;